import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import http from './http'
import '@/scss/styles.scss'
import './registerServiceWorker'
import VeeValidate from 'vee-validate'

Vue.use(VeeValidate)

Vue.config.productionTip = false
// Vue.config.productionTip = process.env.NODE_ENV === 'development'

Object.defineProperties(Vue.prototype, {
  $http: {
    value: http
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
